$.namespace("SCS.ajaxcalls");

SCS.ajaxcalls.init = function(scriptpath, id) {

	$(document).ready(function() {
		if (location.hash == '') {
			$.ajax({
				url : scriptpath + ".html",
				timeout : 10000,
				success : function(data) {
					$('#' + id).html(data);
				}
			}); // Defect ID : 11250 Quicklink in Accordion
		} else {
			$.ajax({
				url : scriptpath + ".html",
				timeout : 10000,
				success : function(data) {
					$('#' + id).html(data);
				}
			});
		}
	});
};

SCS.ajaxcalls.bind = function(scriptpath, id) {
	$(document).on("searchEvent", function(event, selector) {
		var selector1 = encodeURIComponent(selector.replace('#', ''));
		$.ajax({
			url : scriptpath + selector1 + ".html",
			timeout : 10000,
			success : function(data) {
				$('#' + id).html(data);
			}
		});
	});
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/ajaxcalls.js
// module id = 344
// module chunks = 0